import {
    displayShortDateShortYear,
    displayShortDateOrNA,
    displayPercentOrNaTruthyZero,
    NA_DEFAULT,
    tackFootnoteSymbol
} from '../../utils/Format/Format';

import {
    showTackedFootnotes,
    showExpenseWaiverDisclaimer,
    inceptionDateHardCodedToBeRemoved,
    quarterEndBeforeInception
} from '../../utils/fund-info';

import { validateWaiverType } from '../FeesExpenses/util';

// @todo extract titles outside of tables
// and put into cards
export const averageAnnualTableCardUtil = (iClass, ticker) => (gqlResult) => {
    if (!gqlResult) return null;

    const {
        mutualFund: {
            inceptionDate,
            tackedReturnFundInceptionDate,
            standardPerformanceReturns
        }
    } = gqlResult;

    const { quarterlyAnnualReturns, monthlyAnnualReturns } =
        standardPerformanceReturns || {};
    const {
        fundPerformance: {
            asOfDate: quarterlyAsOfDate,
            oneYearReturn: quarterlyOneYearReturn,
            threeYearReturn: quarterlyThreeYearReturn,
            fiveYearReturn: quarterlyFiveYearReturn,
            tenYearReturn: quarterlyTenYearReturn,
            sinceInceptionReturn: quarterlySinceInceptionReturn,
            cumulativeSinceInceptionReturn: quarterlyCumulativeSinceInceptionReturn,
            oneYearReturnTacked: quarterlyOneYearReturnTacked,
            threeYearReturnTacked: quarterlyThreeYearReturnTacked,
            fiveYearReturnTacked: quarterlyFiveYearReturnTacked,
            tenYearReturnTacked: quarterlyTenYearReturnTacked,
            sinceInceptionReturnTacked: quarterlySinceInceptionReturnTacked
        }
    } = quarterlyAnnualReturns || { fundPerformance: {} };

    const {
        fundPerformance: {
            asOfDate: monthlyAsOfDate,
            oneYearReturn: monthlyOneYearReturn,
            threeYearReturn: monthlyThreeYearReturn,
            fiveYearReturn: monthlyFiveYearReturn,
            tenYearReturn: monthlyTenYearReturn,
            sinceInceptionReturn: monthlySinceInceptionReturn,
            cumulativeSinceInceptionReturn: monthlyCumulativeSinceInceptionReturn,
            oneYearReturnTacked: monthlyOneYearReturnTacked,
            threeYearReturnTacked: monthlyThreeYearReturnTacked,
            fiveYearReturnTacked: monthlyFiveYearReturnTacked,
            tenYearReturnTacked: monthlyTenYearReturnTacked,
            sinceInceptionReturnTacked: monthlySinceInceptionReturnTacked
        }
    } = monthlyAnnualReturns || { fundPerformance: {} };

    const topValueOver40 =
        monthlyOneYearReturn >= 40 ||
        monthlyThreeYearReturn >= 40 ||
        quarterlyOneYearReturn >= 40 ||
        quarterlyThreeYearReturn >= 40;

    const tackedReturns = [
        monthlyOneYearReturnTacked,
        monthlyThreeYearReturnTacked,
        monthlyFiveYearReturnTacked,
        monthlyTenYearReturnTacked,
        monthlySinceInceptionReturnTacked,
        quarterlyOneYearReturnTacked,
        quarterlyThreeYearReturnTacked,
        quarterlyFiveYearReturnTacked,
        quarterlyTenYearReturnTacked,
        quarterlySinceInceptionReturnTacked
    ];

    const inceptedAfterQuaterly = quarterEndBeforeInception(inceptionDate);

    const monthlySinceIncep =
        monthlySinceInceptionReturn === null
            ? displayPercentOrNaTruthyZero(
                  monthlyCumulativeSinceInceptionReturn
              )
            : displayPercentOrNaTruthyZero(monthlySinceInceptionReturn);

    const quatelySinceIncep =
        quarterlySinceInceptionReturn === null
            ? displayPercentOrNaTruthyZero(
                  quarterlyCumulativeSinceInceptionReturn
              )
            : displayPercentOrNaTruthyZero(quarterlySinceInceptionReturn);

    const hasTacked = tackedReturns.includes(true);

    let title = `Average Annual Total Returns¹`;
    if (hasTacked && showTackedFootnotes(iClass, ticker)) {
        title += '˒²';
    }

    const headers = [
        title,
        `Monthly (as of ${displayShortDateOrNA(monthlyAsOfDate)})`,
        `Quarterly (as of ${displayShortDateOrNA(quarterlyAsOfDate)})`
    ];

    const returnData = [
        {
            label: '1 Year',
            values: [
                {
                    val1: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(monthlyOneYearReturn)
                },
                {
                    val2: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(quarterlyOneYearReturn)
                }
            ],
            tackFootnoteSymbol:
                tackFootnoteSymbol(monthlyOneYearReturn) ||
                tackFootnoteSymbol(quarterlyOneYearReturn)
        },
        {
            label: '3 Year',
            values: [
                {
                    val1: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(monthlyThreeYearReturn)
                },
                {
                    val2: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(quarterlyThreeYearReturn)
                }
            ],
            tackFootnoteSymbol:
                tackFootnoteSymbol(monthlyThreeYearReturn) ||
                tackFootnoteSymbol(quarterlyThreeYearReturn)
        },
        {
            label: '5 Year',
            values: [
                {
                    val1: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(monthlyFiveYearReturn)
                },
                {
                    val2: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(quarterlyFiveYearReturn)
                }
            ]
        },
        {
            label: '10 Year',
            values: [
                {
                    val1: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(monthlyTenYearReturn)
                },
                {
                    val2: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(quarterlyTenYearReturn)
                }
            ]
        },
        {
            label: `Since Inception (${inceptionDateHardCodedToBeRemoved(
                iClass,
                tackedReturnFundInceptionDate,
                inceptionDate
            )})`,
            values: [
                {
                    val1: inceptedAfterQuaterly ? NA_DEFAULT : monthlySinceIncep
                },
                {
                    val2: inceptedAfterQuaterly ? NA_DEFAULT : quatelySinceIncep
                }
            ]
        }
    ];

    return {
        data: returnData,
        headers,
        title,
        hasTacked,
        topValueOver40,
        quarterlyAsOfDate
    };
};

export const averageAnnualTableCardFeesExpensesUtil = (ticker) => (
    gqlResult
) => {
    if (!gqlResult) return null;

    const {
        mutualFund: {
            dailyYTDTotalReturns,
            grossExpenseRatio,
            netExpenseRatio,
            expenseRatioWaiverType,
            expenseRatioWaiverExpirationDate,
            transactionFee,
            activeMoneyMarketFundMessages,
            standardPerformanceReturns: { threeMonthReturn },
            inceptionDate
        }
    } = gqlResult;

    const { fundReturn, asOfDate } = dailyYTDTotalReturns;

    const inceptedAfterQuaterly = quarterEndBeforeInception(inceptionDate);
    const bottomValueOver40 = fundReturn && fundReturn >= 40;
    const returnData = [
        {
            label: `Daily YTD Return (as of ${
                inceptedAfterQuaterly
                    ? NA_DEFAULT
                    : displayShortDateShortYear(asOfDate)
            })`,
            values: [
                {
                    ytdReturn: inceptedAfterQuaterly
                        ? NA_DEFAULT
                        : displayPercentOrNaTruthyZero(fundReturn)
                }
            ],
            tackFootnoteSymbol: inceptedAfterQuaterly
                ? false
                : tackFootnoteSymbol(fundReturn)
        },
        {
            label: `3 Month Return (as of ${displayShortDateShortYear(
                threeMonthReturn.asOfDate
            )})`,
            values: [
                {
                    ytdReturn: displayPercentOrNaTruthyZero(
                        threeMonthReturn.fundReturn
                    )
                }
            ]
        },
        {
            label: `Gross Expense Ratio${
                showExpenseWaiverDisclaimer(ticker) ? '*' : ''
            }`,
            values: [{ val1: displayPercentOrNaTruthyZero(grossExpenseRatio) }],
            showDefinition: false,
            definition: `The gross expense ratio reflects the fund expenses as stated in the fee table of the fund's prospectus prior to the deduction of any waiver or reimbursement. Expense ratios are as of the most recent prospectus.`
        },
        {
            label: `Net Expense Ratio${
                showExpenseWaiverDisclaimer(ticker) ? '*' : ''
            }`,
            values: [{ val1: displayPercentOrNaTruthyZero(netExpenseRatio) }],
            showDefinition: false,
            definition: `The net expense ratio reflects fund expenses after the deduction of any waiver or reimbursement. Expense ratios are as of the most recent prospectus.`
        },
        {
            label: 'Expense Waiver Type',
            values: [
                {
                    val1: validateWaiverType(expenseRatioWaiverType)
                }
            ]
        },
        {
            label: 'Expense Limitation Expires',
            values: [
                {
                    val1: displayShortDateOrNA(expenseRatioWaiverExpirationDate)
                }
            ]
        }
    ];

    return {
        data: returnData,
        transactionFee,
        activeMoneyMarketFundMessages,
        bottomValueOver40
    };
};

export const threeMonthLiborTickerFootnotesAverage = {
    RPIDX:
        '<sup>2</sup> Effective May 1, 2021, the benchmark for the Dynamic Credit Fund changed to the ICE BofAML US 3-Month Treasury Bill Index in USD. Prior to this change, the benchmark was the 3 Month LIBOR in USD.',
    RPELX:
        '<sup>2</sup> Effective May 1, 2021, the benchmark for the Dynamic Credit Fund - I Class changed to the ICE BofAML US 3-Month Treasury Bill Index in USD. Prior to this change, the benchmark was the 3 Month LIBOR in USD.',
    RPIEX:
        '<sup>2</sup> Effective May 1, 2021, the benchmark for the Dynamic Global Bond Fund changed to the ICE BofAML US 3-Month Treasury Bill Index in USD. Prior to this change, the benchmark was the 3 Month LIBOR in USD.',
    RPEIX:
        '<sup>3</sup> Effective May 1, 2021, the benchmark for the Dynamic Global Bond Fund  - I Class changed to the ICE BofAML US 3-Month Treasury Bill Index in USD. Prior to this change, the benchmark was the 3 Month LIBOR in USD.'
};
